const throttle = require('throttle-debounce/throttle');
const debounce = require('throttle-debounce/debounce');
const config = require('./config.yaml');
const BreadcrumbsController = require('../index.js');

class ShortWidthExpandBreadcrumbsController extends BreadcrumbsController {
	constructor($shortBreadcrumbs) {
		super($shortBreadcrumbs);
	}

	/**
	 * Основной метод проверки, который оперирует хлебными крошками
	 */
	checkBreadcrumbs() {
		try {
			if (this.isFit()) {
				if (this.hasHiddenItems()) {
					let $item = false;
					if (config.typeOfshortening == 'mostLongest') {
						$item = this.getMostShortHiddenItem();
					} else {
						$item = this.getMostRightHiddenItem();
					}

					if ($item && this.tryShowItem($item)) {
						if (config.tooltipTitle) {
							let $dots = $item.find('.js-dots');
							if ($dots) {
								this.removeTooltipFromItem($dots);
							}
						}
						this.checkBreadcrumbs();
					}
				}
			} else {
				let $item = false;
				if (config.typeOfshortening == 'mostLongest') {
					$item = this.getMostLongShownItem();
				} else {
					$item = this.getMostLeftShownItem();
				}

				if ($item && this.tryHideItem($item)) {
					if (config.tooltipTitle) {
						let $dots = $item.find('.js-dots');
						if ($dots) {
							this.addTooltipToItem($dots);
						}
					}

					this.checkBreadcrumbs();
				}
			}
		} catch (e) {
			console.error(`[breadcrumbs] ${e.name}: ${e.message}`);
		}
	}

	/**
	 * Пробует скрыть переданный элемент. При этом, если хлебные
	 * крошки вмещаются в родителя, то элемент скрыт не будет.
	 * @param $item
	 * @returns {boolean}
	 */
	tryHideItem($item) {
		const $bc = this.bc;

		if (!$bc.length) {
			throw new Error('Не передан объект хлебных крошек');
		} else if (!$item.length) {
			throw new Error('Не передан элемент для скрытия');
		} else if ($item.hasClass(this.shortClass)) {
			throw new Error('Элементы уже скрыт');
		}

		let $itemInner = $item.find('.js-inner');
		if (!$itemInner.length) {
			throw new Error('Не найдено внутреннее содержимое элемента');
		}

		let parentWidth = $bc.parent().width();
		let breadcrumbsWidth = this.getBreadcrumbsWidth($bc);

		if (breadcrumbsWidth > parentWidth) {
			$item.addClass(this.shortClass);
			return true;
		} else {
			return false;
		}
	}

	/**
	 * Пробует показать переданный элемент. При этом, если
	 * "ширина текущих хлебных крошек + ширина элемента"
	 * не вмещается в родителя, то элемент не будет показан.
	 * @param $item
	 * @returns {boolean}
	 */
	tryShowItem($item) {
		const $bc = this.bc;

		if (!$bc.length) {
			throw new Error('Не передан объект хлебных крошек');
		} else if (!$item.length) {
			throw new Error('Не передан элемент для открытия');
		} else if (!$item.hasClass(this.shortClass)) {
			throw new Error('Элементы уже открыт');
		}

		let $itemInner = $item.find('.js-inner');
		if (!$itemInner.length) {
			throw new Error('Не найдено внутреннее содержимое элемента');
		}

		let parentWidth = $bc.parent().width();
		let breadcrumbsWidth = this.getBreadcrumbsWidth($bc);
		let itemInnerWidth = $itemInner.width();

		if ((breadcrumbsWidth + itemInnerWidth) < parentWidth) {
			$item.removeClass(this.shortClass);
			return true;
		} else {
			return false;
		}
	}
}


const $breadcrumbs = $('.breadcrumbs--short');
if ($breadcrumbs.length) {
	$breadcrumbs.each(function () {
		const $this = $(this);
		const cShortBreadcrumbsController = new ShortWidthExpandBreadcrumbsController($this);

		$(document).ready(function () {
			if (cShortBreadcrumbsController.isNeedDoingCheck()) {
				cShortBreadcrumbsController.checkBreadcrumbs();
				$(window).on('resize', function () {
					debounce(100, cShortBreadcrumbsController.checkBreadcrumbs());
				});
			}
		});
	});
}



// WEBPACK FOOTER //
// ./temp/components/breadcrumbs/short/index.js